import { render, staticRenderFns } from "./schoolProjectListTwo.vue?vue&type=template&id=05b22522&scoped=true"
import script from "./schoolProjectListTwo.vue?vue&type=script&lang=js"
export * from "./schoolProjectListTwo.vue?vue&type=script&lang=js"
import style0 from "./schoolProjectListTwo.vue?vue&type=style&index=0&id=05b22522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b22522",
  null
  
)

export default component.exports